import { requestService as api } from "../Request.service"  

const API_URL = {
  API_MANAGE: `/ERP/ink/manage.php`,
  API_SEARCH: `/ERP/ink/search.php`,
};



const InkService = () => { 
 
  const create = (parm = {}) => api.post(`${API_URL.API_MANAGE}`, parm);
  const update = (parm = {}) => api.put(`${API_URL.API_MANAGE}`, parm);
  const uploadPic = (formData, config = {}) =>
    api.post(`/ERP/ink/upload_pic.php`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      ...config,
    });
  const deleted = (code) => api.delete(`${API_URL.API_MANAGE}?code=${code}`);
  const get = (code) => api.get(`${API_URL.API_MANAGE}?code=${code}`);
  const search = (parm = {}, config = {}) => api.post(`${API_URL.API_SEARCH}`, parm, {...config, cancle: true});

  return {
    create,
    update,
    uploadPic,
    deleted,
    get,
    search,

  };
};

export default InkService;

